import React from 'react';

import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import FormSection from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';


export const BrowserLimitsSkeleton = () => (
    <FormSection headline="Browser Limits">
        <Group direction="v" alignItems="start">
            <SkeletonItem height={18} width={250}/>
            <FormItemSkeleton labelWidth={200}>
                <SkeletonItem height={32} width={85}/>
            </FormItemSkeleton>
        </Group>
    </FormSection>
);
